module.exports = __webpack_public_path__ + "static/3-skoffin-cd9f30426079de55bdc6feb976e47c58.jpg";